import { EEstimationTargets } from '../../../..';
import { ECurrentErrorField } from '../../../../actions/filters/types';
import { useActions } from '../useActions';
import { useAnalytics } from '../useAnalytics';
import { useSelector } from 'react-redux';
import { selectFilters } from '../../../../selectors';
/**
 * Обработчик клика по итему в геосаджесте (список предложенных адресов)
 * Принимает
 *   * errorMessage - ошибка в фильтрах в поле address
 *   * timerId - ID таймера, по которому будет отправляться аналитика, задан
 * */

export var useHandleSuggestItemClick = function useHandleSuggestItemClick(errorMessage, timerId) {
  var _useSelector = useSelector(selectFilters),
      address = _useSelector.address,
      estimationTarget = _useSelector.estimationTarget;

  var _useActions = useActions(),
      setError = _useActions.setError,
      setAddress = _useActions.setAddress,
      getFlatAreasSuggest = _useActions.getFlatAreasSuggest,
      setNewbuildingId = _useActions.setNewbuildingId;

  var _useAnalytics = useAnalytics(),
      trackAddressPick = _useAnalytics.trackAddressPick;

  return function (params) {
    /** Очищается таймаут, который задается в useAddressProps для аналитики */
    clearTimeout(timerId);
    /** если есть ошибка, она сбросится */

    if (errorMessage) {
      setError({
        currentErrorField: ECurrentErrorField.none,
        errorText: ''
      });
    }

    trackAddressPick(address, params.title, estimationTarget);
    setAddress({
      address: params.title
    });
    /* istanbul ignore else */

    if (estimationTarget === EEstimationTargets.flat) {
      getFlatAreasSuggest(params.title);
    } else if (estimationTarget === EEstimationTargets.newbuilding) {
      setNewbuildingId({
        newbuildingId: params.id
      });
    }
  };
};